__webpack_require__.p = "https://static.recollective.com/v1.6.19-014/_inc/dist/";